import * as React from "react";
import Box from "@mui/material/Box";
import { Label } from "@fluentui/react/lib/Label";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { itemsEditorStyles as styles } from "./itemsEditor.styles";

type ItemRow = LTLState["items"][number];

interface Props {
  item: ItemRow;
  index: number;
  onItemFieldChange: (index: number, field: keyof ItemRow, value: unknown) => void;
  onFieldBlur?: () => void;
}

export function LtlFreightItemHazmatCheckbox({
  item,
  index,
  onItemFieldChange,
  onFieldBlur,
}: Props): React.ReactElement {
  return (
    <Box sx={styles.hazardousGroup}>
      <Box sx={styles.checkboxContainer}>
        <input
          type="checkbox"
          checked={item.isHazardous}
          onChange={(e) => {
            onItemFieldChange(index, "isHazardous", e.target.checked);
            onFieldBlur?.();
          }}
          id={`hazardous-${index}`}
        />
        <Label htmlFor={`hazardous-${index}`} styles={styles.checkboxLabel}>
          Hazardous Material
        </Label>
      </Box>
    </Box>
  );
}
